import { AnchoredLayerSpacing, AnchoredLayerOffset, DEFAULT_POSITION, LayerContextType, FlippedPositions } from '../constants.js';
import { AnimationDirection, AnchoredLayerBoundariesElement, AnchoredLayerPosition, LayerManagerLayer } from '../types.js';
import { Animations } from '../Animations.js';
import React, { PureComponent } from 'react';
import AnchoredLayerContainer from './AnchoredLayerContainer.js';
import Popper from 'popper.js';
import PropTypes from 'prop-types';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Convert the shouldAutomaticallyFlip property into
 * the array format that Popper expects.
 * The first item must not include the
 * edge-position variation, or Popper
 * will not understand it.
 */
function getFlipBehavior(props) {
  return Array.isArray(props.shouldAutomaticallyFlip) && props.position ? [props.position.split('-')[0]].concat(props.shouldAutomaticallyFlip) : null;
}

function offsetArrayToString(offsetArray) {
  if (offsetArray && offsetArray.length > 2) {
    /* eslint-disable no-console */
    console.error('AnchoredLayer.props.offset should be an array of two values.');
    /* eslint-enable no-console */
  }

  return offsetArray ? offsetArray.join(',') : '';
}

var ChildrenContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props));
}); // For importing in NodeJS or SSR environments Element won't be defined so proxy for those cases

var DOMElement = typeof Element === 'undefined' ? function () {} : Element;

var AnchoredLayer = /*#__PURE__*/function (_PureComponent) {
  _inherits(AnchoredLayer, _PureComponent);

  var _super = _createSuper(AnchoredLayer);

  function AnchoredLayer(props) {
    var _this;

    _classCallCheck(this, AnchoredLayer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "context", void 0);

    _defineProperty(_assertThisInitialized(_this), "popper", undefined);

    _defineProperty(_assertThisInitialized(_this), "targetRef", null);

    _defineProperty(_assertThisInitialized(_this), "contentRef", null);

    _defineProperty(_assertThisInitialized(_this), "extractStyles", function (state) {
      if (state) {
        var isOutOfBoundaries = state.attributes ? state.attributes['x-out-of-boundaries'] : undefined;

        if (typeof isOutOfBoundaries !== 'undefined' && isOutOfBoundaries !== false) {
          // Once the content is out of bounds,
          // we stop updating the state to prevent
          // unecessary render cycles, and hide the content
          _this.setState({
            hidden: true
          });
        } else {
          var left = Math.round(state.offsets ? state.offsets.popper.left : 0);
          var top = Math.round(state.offsets ? state.offsets.popper.top : 0); // Update position of given arrowElement
          // by manipulating the DOM element passed

          if (_this.props.arrowElement && state.arrowStyles) {
            var arrowElement = _this.props.arrowElement;
            var arrowStyles = state.arrowStyles;
            arrowElement.style.left = '';
            arrowElement.style.right = '';

            if (arrowStyles.left) {
              arrowElement.style.left = "".concat(arrowStyles.left, "px");
            }

            if (arrowStyles.top) {
              arrowElement.style.top = "".concat(arrowStyles.top, "px");
            }
          }

          _this.setState({
            // cssPosition => position: fixed or absolute
            cssPosition: state.offsets ? state.offsets.popper.position : undefined,
            transform: "translate3d(".concat(left, "px, ").concat(top, "px, 0px)"),
            // state.flipped is either true or undefined
            flipped: !!state.flipped,
            actualPosition: state.position ? state.position : null,
            originalPosition: state.originalPosition ? state.originalPosition : null,
            hidden: false
          });

          if (_this.props.setContentWidthAsAnchorWidth && state.offsets && state.offsets.reference && _this.state.anchorWidth !== state.offsets.reference.width) {
            _this.setState({
              anchorWidth: state.offsets.reference.width
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getChangedProps", function (nextProps, previousProps) {
      return Object.entries(nextProps).reduce(function (accumulator, entry) {
        var _ref = entry,
            _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1]; // Do a shallow comparison between
        // the next props and our existing props


        if (value === previousProps[key]) {
          return accumulator;
        }

        return [].concat(_toConsumableArray(accumulator), [key]);
      }, []);
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialDirection", function () {
      var position = _this.props.position;

      var _ref3 = position.split('-'),
          _ref4 = _slicedToArray(_ref3, 1),
          initialDirection = _ref4[0];

      if (!_this.state.flipped) {
        return initialDirection;
      }

      if (initialDirection === AnimationDirection.Top) {
        return AnimationDirection.Bottom;
      }

      if (initialDirection === AnimationDirection.Bottom) {
        return AnimationDirection.Top;
      }

      if (initialDirection === AnimationDirection.Left) {
        return AnimationDirection.Right;
      }

      if (initialDirection === AnimationDirection.Right) {
        return AnimationDirection.Left;
      }
    });

    _this.state = {
      position: null,
      transform: null,
      flipped: false,
      actualPosition: null,
      // We set these default offsets to prevent a
      // flash of popper content in the wrong position
      // which can cause incorrect height calculations.
      // Popper will calculate these values
      offsets: {
        popper: {
          left: -9999,
          top: -9999
        }
      },
      originalPosition: null,
      anchorWidth: undefined,
      cssPosition: 'absolute'
    };
    return _this;
  }

  _createClass(AnchoredLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.applyPopper(_this2.props);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var previousProps = this.props;
      requestAnimationFrame(function () {
        return _this3.applyPopper(nextProps, previousProps);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.flipped !== this.state.flipped && this.props.onFlippedChange) {
        this.props.onFlippedChange({
          flipped: this.state.flipped,
          actualPosition: this.state.actualPosition ? this.state.actualPosition : null,
          originalPosition: this.state.originalPosition ? this.state.originalPosition : null
        });
      }

      if (this.popper && this.props.setContentWidthAsAnchorWidth && this.state.anchorWidth !== prevState.anchorWidth) {
        this.popper.scheduleUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.popper) {
        this.popper.destroy();
      }
    }
  }, {
    key: "applyPopper",
    value: function applyPopper(props, previousProps) {
      if (!this.targetRef || !this.contentRef) {
        return;
      } // "new Popper(...)" operation is very
      // expensive when called on virtual DOM.
      // This condition reduces the number of
      // calls so we can run our tests faster


      if ( // If there is no content or children
      // don't apply the popper.
      !props.content || !props.children) {
        return;
      } // If _none_ of the props that
      // are used when initializing Popper
      // are changed, don't re-initialize popper


      if (this.popper && previousProps) {
        var changedProps = this.getChangedProps(props, previousProps);

        if (!['offset', 'position', 'shouldAutomaticallyFlip', 'boundariesElement', 'content', 'children', 'inner'].some(function (whitelistedProp) {
          return changedProps.includes(whitelistedProp);
        })) {
          return;
        }
      }

      if (this.popper) {
        this.popper.destroy();
        delete this.popper;
      } // If the AnchoredLayer is being rendered
      // within the currentLayerContext of a modal,
      // set the default boundariesElement to 'scrollParent'.
      // if not rendered in the context of a modal, set the
      // default boundariesElement to 'viewport'. Otherwise,
      // if boundariesElement is passed as a prop, just use that
      // value that's passed in.


      var boundariesElement = this.props.boundariesElement;

      if (this.context.currentLayerContext === LayerManagerLayer.Modal && !boundariesElement) {
        boundariesElement = AnchoredLayerBoundariesElement.ScrollParent;
      } else if (!boundariesElement) {
        boundariesElement = AnchoredLayerBoundariesElement.Viewport;
      } // we wrap our target in a div so that we can
      // safely get a reference to it, but we pass the
      // actual target to popper


      var actualTarget = this.targetRef.firstChild;
      var popperOpts = {
        placement: props.position,
        arrow: this.props.arrowElement,
        // Since we're creating fixed position
        // Layers with LayerManager (causing the
        // contentElement is fixed in place)
        // we need to force Popper.js to use its
        // fixed position mode: it forces the offset
        // calculations when updating to ignore the negative scroll
        // See: https://github.com/FezVrasta/popper.js/blob/ebae3f8cfba128383cbe3114fddb174213243d09/packages/popper/src/utils/getOffsetRectRelativeToArbitraryNode.js#L20-L23
        positionFixed: true,
        onCreate: this.extractStyles,
        onUpdate: this.extractStyles,
        modifiers: {
          // We don't want Popper to be responsible
          // for applying styles to the given content node;
          // we use the state saved in extractStyles to
          // position the AnchoredLayerContent
          applyStyle: {
            enabled: false
          },
          // We need hide to be enabled to
          // know when to stop rendering
          // the AnchoredLayer content
          hide: {
            enabled: true,
            boundariesElement: boundariesElement
          },
          offset: {
            enabled: true,
            offset: offsetArrayToString(this.props.offset)
          },
          flip: {
            enabled: !!this.props.shouldAutomaticallyFlip,
            flipVariations: true,
            boundariesElement: boundariesElement,
            padding: 0
          },
          inner: {
            enabled: !!this.props.inner
          },
          // Defines how `hide` and `flip` work
          // based on the edges of the `boundariesElement`
          // and the reference element's position
          preventOverflow: {
            enabled: true,
            escapeWithReference: !!this.props.shouldEscapeWithAnchor,
            boundariesElement: boundariesElement,
            padding: this.props.boundariesPadding
          },
          keepTogether: {
            enabled: true
          },
          arrow: typeof this.props.arrowElement === 'undefined' ? undefined : {
            enabled: true,
            element: this.props.arrowElement
          }
        }
      };
      var flipBehavior = getFlipBehavior(props);

      if (flipBehavior && popperOpts.modifiers && popperOpts.modifiers.flip) {
        popperOpts.modifiers.flip.behavior = flipBehavior;
      }

      this.popper = new Popper(actualTarget, this.contentRef, popperOpts);
    }
    /* eslint-disable consistent-return */

  }, {
    key: "render",
    value:
    /* eslint-enable consistent-return */
    function render() {
      var _this4 = this;

      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content,
          animation = _this$props.animation;
      var _this$state = this.state,
          anchorWidth = _this$state.anchorWidth,
          cssPosition = _this$state.cssPosition,
          transform = _this$state.transform,
          hidden = _this$state.hidden;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ChildrenContainer, {
        ref: function ref(_ref5) {
          return _this4.targetRef = _ref5;
        }
      }, children), /*#__PURE__*/React.createElement(AnchoredLayerContainer, {
        animation: animation,
        initialDirection: this.getInitialDirection(),
        innerRef: function innerRef(ref) {
          return _this4.contentRef = ref;
        },
        cssPosition: cssPosition,
        transform: transform,
        hidden: hidden,
        containerWidth: anchorWidth
      }, content));
    }
  }]);

  return AnchoredLayer;
}(PureComponent);

_defineProperty(AnchoredLayer, "propTypes", {
  shouldAutomaticallyFlip: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOf(Object.values(AnimationDirection)))]),
  shouldEscapeWithAnchor: PropTypes.bool,
  setContentWidthAsAnchorWidth: PropTypes.bool,
  arrowElement: PropTypes.instanceOf(DOMElement),
  boundariesElement: PropTypes.oneOfType([PropTypes.oneOf(Object.values(AnchoredLayerBoundariesElement)), PropTypes.instanceOf(DOMElement)]),
  boundariesPadding: PropTypes.oneOfType([PropTypes.oneOf(Object.values(AnchoredLayerSpacing)), PropTypes.shape({
    bottom: PropTypes.oneOf(Object.values(AnchoredLayerSpacing)),
    top: PropTypes.oneOf(Object.values(AnchoredLayerSpacing)),
    left: PropTypes.oneOf(Object.values(AnchoredLayerSpacing)),
    right: PropTypes.oneOf(Object.values(AnchoredLayerSpacing))
  })]),
  children: PropTypes.node,
  content: PropTypes.node,
  offset: PropTypes.arrayOf(PropTypes.oneOf([].concat(_toConsumableArray(Object.values(AnchoredLayerOffset)), _toConsumableArray(Object.values(AnchoredLayerOffset).map(function (value) {
    return value * -1;
  }))))),
  onFlippedChange: PropTypes.func,
  position: PropTypes.oneOf(Object.values(AnchoredLayerPosition)),
  animation: PropTypes.oneOf(Object.values(Animations)),
  inner: PropTypes.bool
});

_defineProperty(AnchoredLayer, "contextTypes", {
  currentLayerContext: LayerContextType
});

_defineProperty(AnchoredLayer, "AnimationTypes", Animations);

_defineProperty(AnchoredLayer, "Directions", AnimationDirection);

_defineProperty(AnchoredLayer, "BoundariesElements", AnchoredLayerBoundariesElement);

_defineProperty(AnchoredLayer, "Offset", AnchoredLayerOffset);

_defineProperty(AnchoredLayer, "Positions", AnchoredLayerPosition);

_defineProperty(AnchoredLayer, "FlippedPositions", FlippedPositions);

_defineProperty(AnchoredLayer, "defaultProps", {
  // By default, we want AnchoredLayer
  // to try to keep it's content visible when it hits
  // the edges of its `boundariesElement`
  shouldAutomaticallyFlip: true,
  // don't let defaultProps define a value
  // for boundariesElement, set the default
  // below so we can choose it based on
  // currentLayerContext
  shouldEscapeWithAnchor: true,
  boundariesElement: null,
  boundariesPadding: AnchoredLayerSpacing.Small,
  children: null,
  content: null,
  offset: [AnchoredLayerOffset.None, AnchoredLayerOffset.None],
  onFlippedChange: function onFlippedChange() {},
  position: DEFAULT_POSITION,
  animation: Animations.Slide,
  inner: false
});

export { AnchoredLayer as default };
